import React, { useRef, useState, Fragment } from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { Box } from "@mui/material";
import { Redirect, useHistory, useRouteMatch } from "react-router-dom";
import { Header } from "../../components/layout/header/header";
import { useIntl } from "react-intl";
import learn_group_image from "../../img/landing_page_learning_group.png";
import landing_page_background from "../../img/landing_page_background.png";
import teaching_group_image from "../../img/landing_page_teaching.png";
import landingPageChatAppPreviewImage from "../../img/landing_page.chat_app_preview.png";
import landingPageBlagLogoSquare from "../../img/landing_page.blag_logo_square.svg";
import { HeroSection, FeaturesSection, ErrorBoundary } from "./components";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_COURSES, GET_UNIVERSITIES } from "../../apollo-client/queries";
import { ForgotPwDialog } from "./forgot-pw-dialog";
import { ResetPwDialog } from "./reset-pw-dialog";
import { CopyrightAboutUs } from "./copyright-about-us";
import { LoginSidebar } from "../../components/sidebars/login-sidebar/login-sidebar";
import { SSORegisterSidebar } from "../../components/sidebars/register-sidebar/sso-register-sidebar";
import { showErrorToast } from "../../toast/toast-service";

export const LandingPage = (props) => {
  const themeContext = useTheme();

  const [courseOptions, setCourseOptions] = useState([]);

  const [formValues, setFormValues] = useState({
    university: "",
    course: "",
  });

  const intl = useIntl();
  const routeMatch = useRouteMatch();
  const history = useHistory();

  const chooseUniDropdownRef = useRef(null);

  const { data: universitiesData, loading: loadingUniversites } = useQuery(
    GET_UNIVERSITIES,
    {
      variables: { limit: 999 },
      onError: (error) => {
        showErrorToast(error.message);
      },
    }
  );

  const [getCoursesData, { data: coursesData, loading: loadingCourses }] =
    useLazyQuery(GET_COURSES, {
      variables: {
        title: formValues.course,
        university: formValues.university,
        limit: 25,
      },
      onCompleted: (data) => {
        setCourseOptions(data.courses.courses);
      },
      onError: (error) => {
        showErrorToast(error.message);
      },
      fetchPolicy: "network-only",
    });
  const handleUniversityInputChange = async (event, value) => {
    const universityInput = value && value.name;

    setFormValues({
      ...formValues,
      university: universityInput,
      course: "", // Reset course when university changes
    });

    if (universityInput) {
    await getCoursesData();
    }
  };

  const handleCourseInputChanged = async (event, value) => {
    setFormValues({
      ...formValues,
      course: value,
    });

    if (value && value.length > 2) {
    await getCoursesData();
    }
  };

  const handleCourseSelected = async () => {
    const selectedCourse = courseOptions.find(
      (course) => course.title === formValues.course
    );

    history.push(`/courses/${selectedCourse._id}/teachers`);
  };

  if (localStorage.getItem("token")) return <Redirect to={`/home`} />;

  if (!localStorage.getItem("token"))
    return (
      <Fragment>
        <LoginSidebar />
        <SSORegisterSidebar />
        <ForgotPwDialog
          isOpen={routeMatch.path === "/forgot-password"}
          toggleOpen={() => history.push("/")}
        />
        <ResetPwDialog
          isOpen={routeMatch.path === "/password-reset"}
          toggleOpen={() => history.push("/")}
        />
        <Box 
          data-testid="landing-page" 
          sx={{ 
            width: '100%', 
            maxWidth: '100vw',
            overflow: 'hidden',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            '& *': {
              boxSizing: 'border-box',
            }
          }}
        >
          <Header
            hideNavigation
            hideBurgerMenu
            color={themeContext.brightStuffColor}
            backgroundColor={"transparent"}
            position={"absolute"}
            props={props}
          />
          
          <ErrorBoundary>
            <HeroSection
              universitiesData={universitiesData}
              loadingUniversites={loadingUniversites}
              courseOptions={courseOptions}
              loadingCourses={loadingCourses}
              formValues={formValues}
              onUniversityChange={handleUniversityInputChange}
              onCourseInputChange={handleCourseInputChanged}
              onCourseSelected={handleCourseSelected}
              backgroundImage={landing_page_background}
            />
          </ErrorBoundary>
          
          <FeaturesSection
            learnGroupImage={learn_group_image}
            teachingImage={teaching_group_image}
            chatImage={landingPageChatAppPreviewImage}
            logoImage={landingPageBlagLogoSquare}
          />
          <CopyrightAboutUs />
        </Box>
      </Fragment>
    );
  else return <Redirect to={`/courses/5c1eb802c5faf5136fec6d9d/teachers`} />;
};

